import { useQuery } from '@tanstack/react-query';
import { getRiptideRule } from '../lib/apiClient';

// Settles at most once per 15-minute round; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Forward paper test of Riptide. Hypothetical only. */
export function useRiptideRule() {
  return useQuery({
    queryKey: ['riptide-rule'],
    queryFn: getRiptideRule,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
